import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
export default function MyOrders() {
  const [orders, setOrders] = useState([]);
    const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const token = localStorage.getItem("token"); // Assuming JWT/Sanctum token is stored
        const res = await axios.get("https://cartbackend.wsdstech.com/api/orders", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setOrders(res.data);
      } catch (err) {
        console.error("Failed to fetch orders", err);
      }
    };

    fetchOrders();
  }, []);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get("/user");
        // Check if user is admin — if yes, redirect
      
        setUser(res.data);
      } catch (error) {
        console.error("Error fetching user profile:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);
  console.log(user,"user");
  return (
    <div className="container mt-4">
      <h3>My Orders  <Link to="/profile" className="btn btn-outline-warning ">
        Back to Profile
      </Link></h3>
      
      {orders.length === 0 ? (
        <p className="text-muted">You have no orders yet.</p>
      ) : (
        orders.map((order) => (
          <div key={order.id} className="card mb-3 shadow-sm">
            <div className="card-header">
              <strong>Order #{order.id}</strong> • {new Date(order.created_at).toLocaleString()}
            </div>
            <ul className="list-group list-group-flush">
              {order.items.map((item) => (
                <li key={item.id} className="list-group-item d-flex justify-content-between">
                  <div>
                    <h6 className="my-0">{item.product.name}</h6>
                    <small className="text-muted">
                      {item.quantity} × ₹{item.price}
                    </small>
                  </div>
                  <span>₹{item.quantity * item.price}</span>
                </li>
              ))}
              <li className="list-group-item d-flex justify-content-between">
                <strong>Total</strong>
                <strong>₹{order.items.reduce((sum, i) => sum + i.quantity * i.price, 0)}</strong>
              </li>
            </ul>
          </div>
        ))
      )}
    </div>
  );
}
